<template>
  <div class="image zis-4by3 img-zoom-container">
            <div id="img-zoom-lens" class="img-zoom-lens" v-if="showZoom"></div>
            <img id="myimage" @click="changeZoomState" v-bind:src="url" alt="" />
            <div
              v-if="showZoom"
              id="myresult"
              v-bind:style="{
                backgroundImage: 'url(' + url + ')',
                backgroundPosition: backgroundPosition,
                visibility: displayZoom ? 'visible' : 'hidden'
              }"
              class="img-zoom-result"
            ></div>
          </div>
</template>

<script>

export default {
  props: {
    url: String,
    zoom: Boolean
  },
  data() {
    return {      
      img: {},
      lens: {},
      result: {},
      cx: 0,
      cy: 0,
      backgroundPosition: "",
      displayZoom: true,
      showZoom: false
    };
  },
  
  watch: {
    url: async function (newVal, oldVal) {
      // watch it
      if (newVal !== '') {
        this.detectImageAndDoZoom();
      }
    },
    zoom: function (newVal, oldVal) {
      this.showZoom = newVal
      setTimeout(() => {
        this.detectImageAndDoZoom()
      }, 500)
    }
  },
  methods: {    
    imageZoom(imgID, resultID) {
      //console.log('imageZoom')
      try {
        this.img = document.getElementById(imgID);
        this.result = document.getElementById(resultID);
        /* Create lens: */
        this.lens = document.getElementById("img-zoom-lens"); //document.createElement("div");
        if (!this.lens || !this.result) {
          return;
        }
        this.lens.setAttribute("class", "img-zoom-lens");
        this.lens.setAttribute(
          "style",
          "position:absolute;border: 1px solid #d4d4d4;width: 40px;height: 40px;"
        );
        /* Insert lens: */
        //this.img.parentElement.insertBefore(this.lens, this.img);
        /* Calculate the ratio between result DIV and lens: */
        this.cx = this.result.offsetWidth / this.lens.offsetWidth;
        this.cy = this.result.offsetHeight / this.lens.offsetHeight;
        /* Set background properties for the result DIV */
        //this.result.style.backgroundImage = "url('" + this.img.src + '&rnd=' + Math.random() + "')";
        this.result.style.backgroundSize =
          this.img.width * this.cx + "px " + this.img.height * this.cy + "px";
        /* Execute a function when someone moves the cursor over the image, or the lens: */
        this.lens.removeEventListener("mousemove", this.moveLens, true);
        this.lens.removeEventListener("mousemove", this.moveLens, true);
        
        this.lens.addEventListener("mousemove", this.moveLens, true);
        this.img.addEventListener("mousemove", this.moveLens, true);
        this.lens.removeEventListener("click", this.changeZoomState, true);
        this.lens.addEventListener("click", this.changeZoomState, true);

        // this.img.removeEventListener("mouseover", this.displayZoomYes, true);
        // this.img.removeEventListener("mouseout", this.displayZoomNo, true);        

        // this.img.addEventListener("mouseover", this.displayZoomYes, true);
        // this.img.addEventListener("mouseout", this.displayZoomNo, true);        
        /* And also for touch screens: */
        // this.lens.addEventListener("touchmove", this.moveLens);
        // this.img.addEventListener("touchmove", this.moveLens);
      } catch (err) {
        console.error(err);
      }
    },
    changeZoomState() {
      this.showZoom = !this.showZoom
      if (this.showZoom) {
        setTimeout(() => {
        this.detectImageAndDoZoom()
      }, 200)
      }
    },
    moveLens(e) {
      if (!this.lens || !this.result) {
        return;
      }
      //console.log('moveLens', e)
      var pos, x, y;
      /* Prevent any other actions that may occur when moving over the image */
      e.preventDefault();
      /* Get the cursor's x and y positions: */
      pos = this.getCursorPos(e);
      /* Calculate the position of the lens: */
      x = pos.x - this.lens.offsetWidth / 2;
      y = pos.y - this.lens.offsetHeight / 2;
      /* Prevent the lens from being positioned outside the image: */
      if (x > this.img.width - this.lens.offsetWidth) {
        x = this.img.width - this.lens.offsetWidth;
      }
      if (x < 0) {
        x = 0;
      }
      if (y > this.img.height - this.lens.offsetHeight) {
        y = this.img.height - this.lens.offsetHeight;
      }
      if (y < 0) {
        y = 0;
      }
      /* Set the position of the lens: */
      this.lens.style.left = x + "px";
      this.lens.style.top = y + "px";
      /* Display what the lens "sees": */
      //this.result.style.backgroundPosition = "-" + x * this.cx + "px -" + y * this.cy + "px";
      this.backgroundPosition = "-" + x * this.cx + "px -" + y * this.cy + "px";      
      //this.resultVisible = true

    },
    getCursorPos(e) {
      var a,
        x = 0,
        y = 0;
      e = e || window.event;
      /* Get the x and y positions of the image: */
      a = this.img.getBoundingClientRect();
      /* Calculate the cursor's x and y coordinates, relative to the image: */
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /* Consider any page scrolling: */
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return { x: x, y: y };
    },
    codeView() {
      this.showPre = !this.showPre
      setTimeout(() => {
        this.detectImageAndDoZoom();
      }, 200)
      
    },
    detectImageAndDoZoom() {
      const myimage = document.getElementById("myimage");

      if (myimage) {
        let t = this;
        myimage.onload = () => {
          t.imageZoom("myimage", "myresult");
        };
        myimage.src = this.url;
      }
    }
  },
};
</script>
<style scoped>

.img-zoom-container {
  position: relative;
}
* {
  box-sizing: border-box;
}
.img-zoom-lens {
  position: absolute;
  border: 1px solid #d4d4d4;
  /*set the size of the lens:*/
  width: 40px;
  height: 40px;
}

.img-zoom-result {
  border: 0px solid #d4d4d4;
  margin-top: 0.5rem;
  /*set the size of the result div:*/
  width: 300px;
  height: 300px;
  position: absolute;
  top: -8px;
  z-index: 100;
  right: -310px;
}
</style>
